module.exports = __webpack_public_path__ + "img/fundermax-obra-3-1.eb9c36fe.jpg";